import angular from 'angular';
import testDocument from './testDocument';
import controller from './test-documents.controller';
import directive from './test-documents.directive';


export default angular.module('app.components.advisory.bcp.testDocuments', [
  testDocument
])
  .directive('bcpTestDocuments', directive)
  .controller('TestDocumentsController', controller)
  .name;

console.log('app.components.advisory.bcp.testDocuments created');
